<template>
	<div class="modal-rename-clip-container flex-col items-center">
		<h5
			class="modal-rename-clip-title text-white font-uppercase"
		>
			{{ $tc('modals.renameClipsModal.title') }}
		</h5>
		<ValidationObserver
			v-slot="{ invalid }"
			tag="div"
			class="modal-rename-clips"
		>
			<h6 class="modal-rename-clip-body text-white">
				<TextInput
					v-model="clipName"
					:placeholder="$tc('labels.tagTitlePlaceholder')"
					:label="$tc('modals.modalBreakdown.nameTheMomentText')"
					name="title"
					class="small-text"
					rules="required|min:3|max:50"
				/>
			</h6>
			<div class="modal-rename-clip-buttons flex">
				<button
					class="button-light-blue button-grey font-regular font-uppercase text-black mr-5 flex-center"
					@click="onClose"
				>
					{{ $tc('modals.DeleteTagConfirm.cancelButtonText') }}
				</button>
				<button
					class="button-light-blue font-regular font-uppercase text-black ml-5 flex-center"
					:disabled="invalid"
					@click="onConfirm(clipName)"
				>
					{{ $tc('actions.rename') }}
				</button>
			</div>
		</ValidationObserver>
	</div>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import { ModalMixin } from '~/assets/vue/mixins'
import TextInput from '~/components/interface/TextInput'

export default {
	name: 'ModalRenameClipConfirm',
	components: {
		TextInput,
		ValidationObserver
	},
	mixins: [ModalMixin],
	props: {
		options: {
			type: Object,
			required: true
		}
	},
	data: () => ({ clipName: '' }),
	mounted () {
		this.clipName = this.options.clipName
	}
}
</script>

<style lang="scss">
.modal-overlay {
	backdrop-filter: blur(20px);
	-webkit-backdrop-filter: blur(20px);
	transition: 0.5s ease-in-out;
	.modal-rename-clip-container {
		max-width: 425px;
		min-height: 288px;
		width: 100%;
		padding: 30px;
		border-radius: 11px;
		backdrop-filter: blur(10px);
		-webkit-backdrop-filter: blur(10px);
		background-color: rgba(40, 40, 40, 0.85);
		box-shadow: 1px 2px 20px 0 rgba(0, 0, 0, 0.4);
		.modal-rename-clip-title {
			letter-spacing: 0.72px;
		}
		.modal-rename-clip-body {
			padding: 36px 20px 50px 20px;
			letter-spacing: 0.98px;
			margin-right: auto;
			width: 100%;

			.text-input {
				border-bottom: 0.8px solid #FFFFFF;
				color: #FFFFFF;
			}

			.text-input-wrap .text-input.validation-error {
				border-color: #b70101;
			}
		}

		&.delete-clips-container {
			min-height: 270px;
		}

		.modal-rename-clip-buttons {
			@include respond-below(phone) {
				flex-direction: column;
			}

			button {
				padding: 8px 50px;
				@include respond-below(phone) {
					margin: 5px;
					flex-direction: column;
				}
			}
		}
	}

	.button-grey {
		background-color: #5c5e5f;
		color: #FFFFFF;
	}
}
</style>
